<template lang="pug">
section.refugios-temporales
  YearSelectorPanel.year-panel
  .familias-censo
    span
      strong Familias Censadas:
      | {{cantFamiliasCensadas}}
  div
    v-btn(outline round small :dark="!dialog1" color="primary" @click='dialog1=true')
      v-icon(dark color="#d96c17") notification_important
      span Censo a familias de los Albergues
    v-btn(outline round small :dark="!dialog2" color="primary" @click='dialog2=true')
      v-icon(dark color="#d96c17") notification_important
      span Censo de Albergues
  input.search.elevation-5(:value="refugioSearchText" ref="searchInput" placeholder="Buscar" @input="searchRefugios($event)")
  .asu-title Albergues y Familias Censadas

  v-expansion-panel.refugios-list(v-model="expansionPanelNumber")
    v-expansion-panel-content(
      v-for="({ properties }, index) in refugiosSearched.features"
      ref="refugios"
      :id="`refugio-${properties.nro}`"
      :key="`refugio-${properties.nro}`"
      @click.native="onClickItem($event, properties)"
    )
      template(v-slot:header)
        span {{properties.nombre}}
      RefugioPanel(:refugio="properties" :expanded="shouldBeExpanded(properties)")

  v-dialog(v-model='dialog1', scrollable, max-width='1200px')
    v-card
      v-card-title
        .asu-title Censo a familias de los Albergues
        v-btn(icon @click.stop="dialog1=false" style="position: absolute; right: 0; top: 0;")
          i.material-icons clear
      v-card-text(style="height: 500px;")
        .subheading
          span Formulario
          DownloadButton.download-censo(:href="formulario1Link" type="link")
        .subheading
          span Datos recolectados
          DownloadButton.download-censo(:href="datosRecolectados1Link" type="link")
        p El Censo de las familias de los refugios tiene por objetivo inventariar el número de las familias albergadas en los refugios y recabar sus
          | datos socio-demográficos, económicos y de asistencia, como insumos para el análisis de información que permita coordinar la asistencia social
          | y de emergencia y para evaluación de alternativas de solución definitivas para el momento del retorno a los lugares originales.

        p La ficha censal utilizada fue facilitada por la Cruz Roja Paraguaya, actualizada en el marco del Apoyo del AsuParticipa al Censo de los Refugios y familias 2018.

        p El cuestionario aplicado a nivel familiar en su primera parte levanta información relacionada al tipo de organización al que pertenece, bajo
          | qué Centro de Operaciones de emergencia (COE) se encuentra afectado el refugio, cuál es su lugar original de residencia antes de la situación
          | de emergencia, en qué fecha ingresó la familia al refugio, si recibió o no asistencia/ayuda y de quién o quiénes (Municipalidad, Secretaría
          | de Emergencia Nacional) y los riesgos que se perciben en el Refugio (violencia, maltrato, inseguridad, insuficiencia alimentaria, incendio,
          | conflicto con los vecinos, otros).

        p La segunda parte se refiere a un inventario de los bienes y servicios de la familia, tales como si tienen animales, cuáles; tienen acceso a
          | agua, de dónde y cómo. Si tienen acceso a ducha y baño y si éstos están separados por género. Por último en ésta parte, cómo realizan la
          | disposición final de los residuos sólidos generados.

        p La tercera parte reúne información de identificación del jefe/a de hogar, su nombre y apellido, edad, género, si es mujer se le pregunta si
          | está embarazada o no. Se registra número de documento y de teléfono, se consulta cuál es la ocupación laboral y si ésta se encuentra afectada
          | por la inundación. La ficha recoge información sobre el nivel educativo, estado de salud actual, discapacidad registrada o no en SENADIS y
          | por último si el jefe de hogar o algún otro integrante de la familia es beneficiario de algún Programa de Protección del Gobierno.

  v-dialog(v-model='dialog2', scrollable, max-width='1200px')
    v-card
      v-card-title
        .asu-title Censo de Albergues
        v-btn(icon @click.stop="dialog2=false" style="position: absolute; right: 0; top: 0;")
          i.material-icons clear
      v-card-text(style="height: 500px;")
        .subheading
          span Formulario
          DownloadButton.download-censo(:href="formulario2Link" type="link")
        .subheading
          span Datos recolectados
          DownloadButton.download-censo(:href="datosRecolectados2Link" type="link")
        p Con el objetivo de evaluar las condiciones físicas y de calidad de los albergues activados en la ciudad de Asunción, en épocas de inundaciones,
          | de modo a coordinar la asistencia de emergencia, la Dirección de Dirección General de Gestión y Reducción de Riesgos y Desastres (DGRRD) de
          | la Municipalidad de Asunción – MCA, ha facilitado el “Cuestionario Evaluación albergues” y ha sido actualizado en el marco del Apoyo del
          | AsuParticipa[1][1] al Censo de los Refugios y familias 2018 (Proyecto encarado conjuntamente con la MCA, Cruz Roja Paraguaya - CRP y el
          | Proyecto AsuParticipa).

        p El Cuestionario se aplica por albergue y en su primera parte reúne información relativa a la Identificación del albergue: nombre, ubicación
          | georefenciada, Centro de operaciones de emergencia – COE al que pertenece, si el lugar ya fue utilizado como albergue anteriormente, si qué
          | tipo de predio es (espacio público, municipal, estatal u otros) y datos de la persona e institución que autorizó su uso como refugio, datos
          | de los referentes principales de la Dirección General de Gestión y Reducción de Riesgos y Desastres (DGRRD) y de la Secretaría de Emergencia
          | Nacional y por último cantidad máxima de familias albergadas en el Refugio.

        p En la segunda parte, el Cuestionario recoge información que permite evaluar el nivel de acceso, disponibilidad, condiciones de formalidad,
          | seguridad, salubridad, equidad, inclusión y calidad de los servicios disponibles en el refugio, tales como abastecimiento de agua, sistema de
          | eliminación de excretas, duchas, conexión eléctrica, disposición de residuos sólidos, espacios de lavandería, recreación, depósitos, animales
          | y espacios de atención médica.

        p La tercera y última parte se refiere a información sobre el tipo y frecuencia de exposición a amenazas y grado de acceso a servicios de
          | emergencia con los que cuenta el Refugio. Amenazas tales como inundaciones, incendios, derrumbe, electrocución, consumo o venta de drogas,
          | conflictos comunitarios, polución sonora, entre otros y la distancia más cercana a los servicios de comisaria, atención médica, bomberos,
          | transporte y finalmente si el albergue cuenta o no con un sistema de evacuación ante emergencias.

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getArray } from '@/utils/array.js'
import { scrollElementIfExistInList, findIndexElementInHtmlListByIdEndsWith } from '@/utils/dom.js'

export default {
  components: {
    RefugioPanel: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab3/RefugioPanel'),
    YearSelectorPanel: _ => import('@/components/map/solucion-a-corto-plazo/panel/YearSelectorPanel')
  },
  mounted () {
    this.getCantFamiliasCensadas()
    this.expandCurrentRefugioNro()
    this.scrollToRefugio()
  },
  data: () => ({
    cantFamiliasCensadas: 0,
    isAutomaticClickFromMap: false,
    expansionPanelNumber: null,
    dialog1: false,
    dialog2: false,
    formulario1Link: 'https://drive.google.com/open?id=1vODtAAF4ghDBzhbwWdM7YAVEcuVJ63xG',
    formulario2Link: 'https://drive.google.com/open?id=1v1mLIbHfrtse_7UAOwDiQCxDeqZier0C',
    datosRecolectados1Link: 'https://drive.google.com/file/d/19OMEASRJ0RDl-JyLKyXgBQIGJIilk5oi/view',
    datosRecolectados2Link: 'https://drive.google.com/open?id=1wQS2VkOGyrdc79soOZ2omHHPwMERuo8d'
  }),
  methods: {
    ...mapActions([ 'searchRefugiosFilter', 'setCurrentRefugioAndUpdateRoute' ]),
    onClickItem ($event, refugio) {
      $event.stopPropagation()
      if (this.shouldBeExpanded(refugio)) return
      this.setCurrentRefugioAndUpdateRoute({ refugio })
    },
    scrollToRefugio () {
      const self = this
      const currentRefugioNro = self.currentRefugioNro
      if (self.refugioElementList.length && currentRefugioNro && self.tabContentParentElement) {
        setTimeout(() => {
          scrollElementIfExistInList(self.refugioElementList, currentRefugioNro, self.tabContentParentElement)
        }, 500)
      }
    },
    shouldBeExpanded (refugio) {
      return this.currentRefugioNro === refugio.nro
    },
    getCantFamiliasCensadas () {
      const self = this
      self.cantFamiliasCensadas = 0
      getArray(this.refugiosSearched.features).map(r => r.properties.nro).forEach(nro => {
        self.cantFamiliasCensadas += parseInt(this.getCantidadFamiliasInCensoByRefugioNro(nro))
      })
    },
    searchRefugios ({ data }) {
      setTimeout(() => {
        this.searchRefugiosFilter(this.$refs.searchInput.value)
      })
    },
    expandCurrentRefugioNro () {
      const self = this
      setTimeout(() => {
        if (self.currentRefugioNro) {
          const index = findIndexElementInHtmlListByIdEndsWith(self.refugioElementList, self.currentRefugioNro)
          if ((index !== undefined || index !== null) && self.expansionPanelNumber !== index) {
            self.expansionPanelNumber = index
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters([ 'refugiosCensados', 'refugiosSearched', 'getCantidadFamiliasInCensoByRefugioNro', 'refugioSearchText' ]),
    currentRefugioNro () {
      return this.$route.query.refugio_nro
    },
    tabContentParentElement () {
      return this.$parent && this.$parent.$parent && this.$parent.$parent.$el
    },
    refugioElementList () {
      return (this.$refs.refugios && this.$refs.refugios.map(v => v.$el)) || []
    }
  },
  watch: {
    refugiosCensados () {
      this.getCantFamiliasCensadas()
      this.scrollToRefugio()
    },
    refugiosSearched () {
      this.getCantFamiliasCensadas()
    },
    currentRefugioNro () {
      this.expandCurrentRefugioNro()
      this.scrollToRefugio()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.asu-title
  font-weight: bold
  color: $color_0
  margin: $f10px 0 $f10px 0
  .v-card__title &
    font-size: $f20px
    font-family: Raleway
    padding: 0
    margin: 0

.v-card__text
  .subheading
    color: $color_0
    display: flex
    align-items: center
    justify-content: space-between
    font-family: Raleway
    font-weight: bold
  p
    font-family: Raleway
    color: $gray_color

.refugios-temporales
  input.search
    border: 0
    width: 100%
    border-radius: $f14px
    height: $f28px
    padding: 0 $f15px
    margin-top: $f10px
    &:focus
      outline: 0
      box-shadow: 0 5px 6px -3px rgba(0,0,0,.12), 0 9px 12px 1px rgba(0,0,0,.1), 0 3px 16px 2px rgba(0,0,0,.11)
  .refugio-list-expandable
    padding-top: 0
  .v-expansion-panel >>>
    .v-expansion-panel__header
      color: $color_0
      font-weight: bold
      font-size: $f16px
      padding: $f10px $f12px
  .familias-censo
    font-size: $f16px
    span:first-child
      padding-right: $f20px
  .year-panel
    display: inline
  .download-censo
    display inline-block

</style>
